/**
 * Concept camera/world modes (concept L122–127). v1 ships 'classic' (landscape) and 'phone' (portrait);
 * 'canyon' and 'bridge' are kept for v1.1 (GDD §2).
 */
export type ModeName = 'classic' | 'phone' | 'canyon' | 'bridge';

/**
 * 'concept' reproduces the concept renderer exactly (parity tests); 'gdd' applies the upgrades GDD v1.0.1
 * requires (master plan D1–D4). Production always uses 'gdd'.
 */
export type Fidelity = 'concept' | 'gdd';

export interface Mode {
  world: 'valley' | 'canyon';
  look: 'morning' | 'sunset' | 'dusk';
  cam: 'top' | 'chase' | 'bridge';
  fov: number;
  camH?: number;
  camA?: number;
  camB?: number;
  shadow: number;
  alt?: number;
  speed?: number;
  loop: boolean;
  game?: boolean;
  res: [number, number];
}

export const MODES: Record<ModeName, Mode> = {
  classic: {
    world: 'valley',
    look: 'morning',
    cam: 'top',
    fov: 40,
    camH: 165,
    camA: 9,
    camB: 50,
    shadow: 150,
    alt: 12,
    speed: 44,
    loop: true,
    game: true,
    res: [240, 660],
  },
  phone: {
    world: 'valley',
    look: 'morning',
    cam: 'top',
    fov: 58,
    camH: 150,
    camA: 16,
    camB: 30,
    shadow: 130,
    alt: 12,
    speed: 40,
    loop: true,
    game: true,
    res: [170, 520],
  },
  canyon: {
    world: 'canyon',
    look: 'sunset',
    cam: 'chase',
    fov: 60,
    shadow: 170,
    alt: 10,
    speed: 54,
    loop: true,
    res: [240, 660],
  },
  bridge: { world: 'valley', look: 'dusk', cam: 'bridge', fov: 38, shadow: 160, loop: false, res: [220, 480] },
};
